import React from 'react';

import StepConfigurationViewTemplate, {
  StepConfigurationViewTemplateProps,
} from 'analysis-tool/ui/view-templates/StepConfigurationViewTemplate';
import FileChooser from 'ui-library/FileChooser';
import FileList from 'ui-library/FileList';
import FileRow from 'ui-library/FileRow';
import Stepper, {StepperStep} from 'ui-library/stepper/Stepper';

import {
  getColumnMappingStepperStep,
  ColumnMappingStepperStepProps,
} from '../column-mapping/ColumnMappingStepperStep';
import DataFrameNameField, {DataFrameNameFieldProps} from '../steps/DataFrameNameField';

const ALLOWED_FILENAME_EXTENSIONS = '.csv';

export interface FileUploadState {
  file: File | null;
  s3URL: string | null;
  errorMessage: string | null;
}
export interface UploadCSVFormProps {
  file?: File | null;
  onRemoveFile: () => void;
  onSelectFile: (file: File) => void;
}

export interface UploadCSVStepperFormProps {
  stepConfigurationViewTemplateProps: Omit<StepConfigurationViewTemplateProps, 'children'>;
  dataFrameNameFieldProps: DataFrameNameFieldProps;
  fileProps: UploadCSVFormProps;
  columnMappingProps?: ColumnMappingStepperStepProps;
}

export function UploadCSVForm({file, onRemoveFile, onSelectFile}: UploadCSVFormProps): JSX.Element {
  return (
    <div>
      {(() => {
        if (file) {
          return (
            <FileList>
              <FileRow file={file} onRequestRemove={onRemoveFile} />
            </FileList>
          );
        } else {
          return (
            <FileChooser accept={ALLOWED_FILENAME_EXTENSIONS} multiple={false} onSelectFiles={onSelectFile} />
          );
        }
      })()}
    </div>
  );
}

export default function UploadCSVStepperForm({
  stepConfigurationViewTemplateProps,
  dataFrameNameFieldProps,
  fileProps,
  columnMappingProps,
}: UploadCSVStepperFormProps): JSX.Element {
  return (
    <StepConfigurationViewTemplate {...stepConfigurationViewTemplateProps}>
      <Stepper>
        <StepperStep title="Upload CSV">
          <UploadCSVForm {...fileProps} />
        </StepperStep>
        {columnMappingProps != null && getColumnMappingStepperStep(columnMappingProps)}
        <StepperStep title="Name table">
          <DataFrameNameField {...dataFrameNameFieldProps} />
        </StepperStep>
      </Stepper>
    </StepConfigurationViewTemplate>
  );
}
